(function(){
    'use strict';
   
    angular
    .module('notification')
    .controller('NotificationController', NotificationController);
 
    NotificationController.$inject = ['NotificationService','$interval','$window'];
   
    function NotificationController(NotificationService,$interval,$window)
    {  
    	var nc =  this;
    	nc.visible = false;
        nc.task = 0;
        nc.data = {};
        nc.reloadRoute = function()
        {
             $window.location.reload();
 
        }
        $interval(function() {
        // your stuff          
            NotificationService.data().then(function(data){
                console.log(data);
                nc.task = data.task;
                nc.data = data.data;
                if(nc.task)
                    nc.visible=true;

            });
        }, 1000);
    }


})();